import React from 'react';

//Components
import { Switch, Route } from 'react-router-dom';

//Routes
import EditAccount from '../EditAccount/EditAccount';
import EditPassword from '../EditPassword/EditPassword';

import { ROUTER_PATH } from '../../../../const/ROUTER_PATH';

const Account = () => (
    <Switch>
        <Route
            path={ROUTER_PATH.PROFILE_ACCOUNT}
            exact
            component={EditAccount}
        />
        <Route
            path={ROUTER_PATH.PROFILE_ACCOUNT_PASSWORD}
            component={EditPassword}
        />
    </Switch>
);

export default Account
